import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import SEO from '../../components/base/SEO';
import TestimonialCard from './components/TestimonialCard';

export default function TestimonialsPage() {
  const { t } = useTranslation(['testimonials', 'common']);

  const testimonials = [
    {
      id: 1,
      name: t('testimonials:testimonial1.name'),
      category: t('testimonials:testimonial1.category'),
      text: t('testimonials:testimonial1.text'),
      image: 'https://public.readdy.ai/ai/img_res/710cc162894a7bdaa1cdd00378e86c3e.jpg',
    },
    {
      id: 2,
      name: t('testimonials:testimonial2.name'),
      category: t('testimonials:testimonial2.category'),
      text: t('testimonials:testimonial2.text'),
      image: 'https://readdy.ai/api/search-image?query=Studio%20portrait%20of%20a%20blonde%20woman%20in%20her%20forties%20with%20long%20wavy%20hair%2C%20wearing%20a%20sage%20green%20turtleneck%20sweater%2C%20minimal%20makeup%2C%20calm%20and%20composed%20expression%2C%20clean%20white%20studio%20background%2C%20professional%20headshot%20style%2C%20mature%20elegance%20and%20confidence&width=400&height=400&seq=t2-blonde-wavy-studio&orientation=squarish',
    },
    {
      id: 3,
      name: t('testimonials:testimonial3.name'),
      category: t('testimonials:testimonial3.category'),
      text: t('testimonials:testimonial3.text'),
      image: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20red%20haired%20woman%20in%20her%20early%20thirties%20with%20freckles%20and%20a%20bright%20genuine%20laugh%2C%20wearing%20a%20casual%20denim%20jacket%2C%20photographed%20in%20a%20bright%20airy%20cafe%20interior%2C%20natural%20window%20light%2C%20candid%20and%20joyful%20lifestyle%20photo%2C%20warm%20and%20approachable%20personality&width=400&height=400&seq=t3-redhead-cafe-laugh&orientation=squarish',
    },
    {
      id: 4,
      name: t('testimonials:testimonial4.name'),
      category: t('testimonials:testimonial4.category'),
      text: t('testimonials:testimonial4.text'),
      image: 'https://public.readdy.ai/ai/img_res/edited_f4507cf30270661e27039c0507cc49ed_12d889a2.jpg',
    },
    {
      id: 5,
      name: t('testimonials:testimonial5.name'),
      category: t('testimonials:testimonial5.category'),
      text: t('testimonials:testimonial5.text'),
      image: 'https://readdy.ai/api/search-image?query=Elegant%20Asian%20woman%20in%20her%20mid%20thirties%20with%20sleek%20straight%20black%20hair%2C%20wearing%20a%20beige%20silk%20blouse%2C%20serene%20and%20thoughtful%20expression%2C%20photographed%20in%20a%20minimalist%20Scandinavian%20interior%20with%20plants%2C%20soft%20diffused%20light%2C%20refined%20and%20sophisticated%20portrait&width=400&height=400&seq=t5-asian-silk-blouse&orientation=squarish',
    },
    {
      id: 6,
      name: t('testimonials:testimonial6.name'),
      category: t('testimonials:testimonial6.category'),
      text: t('testimonials:testimonial6.text'),
      image: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20mature%20woman%20in%20her%20early%20fifties%20with%20silver%20grey%20hair%20in%20a%20chic%20bob%20cut%2C%20wearing%20a%20structured%20blazer%20in%20olive%20green%2C%20warm%20confident%20smile%2C%20photographed%20outdoors%20in%20an%20urban%20setting%20with%20soft%20bokeh%20background%2C%20timeless%20style%20and%20grace&width=400&height=400&seq=t6-silver-bob-urban&orientation=squarish',
    },
  ];

  return (
    <div className="min-h-screen bg-[#FAF9F6]">
      <SEO
        title={t('testimonials:seo.title')}
        description={t('testimonials:seo.description')}
        keywords={t('testimonials:seo.keywords')}
        ogImage="https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20confident%20young%20woman%20in%20her%20thirties%20with%20healthy%20glowing%20skin%20and%20radiant%20smile%2C%20natural%20beauty%2C%20wellness%20lifestyle%2C%20clean%20minimalist%20background%20in%20soft%20sage%20green%20tones%2C%20high-end%20portrait%20photography%2C%20quiet%20luxury%20aesthetic%2C%20sophisticated%20and%20elegant%2C%20natural%20lighting%2C%20genuine%20happiness%20and%20vitality&width=400&height=400&seq=testimonial-woman-1&orientation=squarish"
      />
      <Navigation />

      <div className="pt-20 sm:pt-32 pb-14 sm:pb-20 px-5 sm:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center mb-10 sm:mb-20">
            <h1 className="text-2xl sm:text-4xl md:text-6xl font-light text-[#4A5D44] mb-4 sm:mb-6 leading-tight" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
              {t('testimonials:hero.title')}
            </h1>
            <div className="w-16 sm:w-24 h-px bg-[#8B9D83] mx-auto mb-5 sm:mb-8"></div>
            <p className="text-sm sm:text-lg font-light text-gray-600 max-w-3xl mx-auto leading-relaxed">
              {t('testimonials:hero.description')}
            </p>
          </div>

          {/* Testimonials Grid */}
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-10 mb-12 sm:mb-20">
            {testimonials.map((testimonial) => (
              <TestimonialCard key={testimonial.id} {...testimonial} />
            ))}
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-[#8B9D83]/10 to-[#B8D4A8]/10 rounded-lg p-8 sm:p-16 text-center">
            <h2 className="text-xl sm:text-3xl md:text-5xl font-light text-[#4A5D44] mb-4 sm:mb-6 leading-tight" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
              {t('testimonials:cta.title')}
            </h2>
            <p className="text-sm sm:text-lg font-light text-gray-600 mb-6 sm:mb-10 max-w-2xl mx-auto leading-relaxed">
              {t('testimonials:cta.description')}
            </p>
            <Link
              to="/payment"
              className="inline-block px-7 sm:px-12 py-3 sm:py-4 bg-[#8B9D83] text-white text-xs sm:text-sm font-light tracking-widest uppercase rounded-sm hover:bg-[#7A8C72] transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              aria-label={t('testimonials:cta.buttonAria')}
            >
              {t('testimonials:cta.button')}
            </Link>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}